/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as KaryawanRouteImport } from './routes/karyawan'
import { Route as PeriodeRouteImport } from './routes/periode'
import { Route as PeriodePeriodIdRouteImport } from './routes/periode.$periodId'
import { Route as IndexRouteImport } from './routes/index'

const KaryawanRoute = KaryawanRouteImport.update({
  id: '/karyawan',
  path: '/karyawan',
  getParentRoute: () => rootRouteImport,
} as any)
const PeriodeRoute = PeriodeRouteImport.update({
  id: '/periode',
  path: '/periode',
  getParentRoute: () => rootRouteImport,
} as any)
const PeriodePeriodIdRoute = PeriodePeriodIdRouteImport.update({
  id: '/periode/$periodId',
  path: '/periode/$periodId',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/karyawan': typeof KaryawanRoute
  '/periode': typeof PeriodeRoute
  '/periode/$periodId': typeof PeriodePeriodIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/karyawan': typeof KaryawanRoute
  '/periode': typeof PeriodeRoute
  '/periode/$periodId': typeof PeriodePeriodIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/karyawan': typeof KaryawanRoute
  '/periode': typeof PeriodeRoute
  '/periode/$periodId': typeof PeriodePeriodIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/karyawan' | '/periode' | '/periode/$periodId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/karyawan' | '/periode' | '/periode/$periodId'
  id:
    | '__root__'
    | '/'
    | '/karyawan'
    | '/periode'
    | '/periode/$periodId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  KaryawanRoute: typeof KaryawanRoute
  PeriodeRoute: typeof PeriodeRoute
  PeriodePeriodIdRoute: typeof PeriodePeriodIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/karyawan': {
      id: '/karyawan'
      path: '/karyawan'
      fullPath: '/karyawan'
      preLoaderRoute: typeof KaryawanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/periode': {
      id: '/periode'
      path: '/periode'
      fullPath: '/periode'
      preLoaderRoute: typeof PeriodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/periode/$periodId': {
      id: '/periode/$periodId'
      path: '/periode/$periodId'
      fullPath: '/periode/$periodId'
      preLoaderRoute: typeof PeriodePeriodIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  KaryawanRoute: KaryawanRoute,
  PeriodeRoute: PeriodeRoute,
  PeriodePeriodIdRoute: PeriodePeriodIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { createStart } from '@tanstack/react-start'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
  }
}
